import { Country, Filters, Option, PageName, ShareType } from '@utils/pageConfig/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { SortingOptionsType } from '@components/design/migrated/Table';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { SaleType } from '@models/OpportunityReview';
import { ProductType } from '@pages/product-analyzer/Product';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { BaseApiParams } from '@services/Types';
import { CollectionLiveData } from '@components/collections/Model';

export class ExportPerformanceBySegmentResp {
  salesRecordsFound = false;
  kpiDataDto: KpiDataDto[] = [];
}

export class KpiDataDto {
  brandName: string = '';
  kpiData: KpiMarketAverageData[] = [];
}

export class KpiMarketAverageData {
  kpiType: string = '';
  saleType?: SaleType;
  marketAverage: BaseChartResp[] = [];
}

export class BaseChartResp {
  period: string = '';
  value: number = 0;
}

export interface PerformanceAnalysisParam extends BaseApiParams, CollectionLiveData {
  clientId: number;
  productType: ProductType;
  productGroup: Option[];
  countries: Country[];
  period: string;
  comparisonPeriod: RelativePeriod | BaseTimePeriod;
  periodType: Periodicity;
  selectedGrowthType: string;
  saleType: string;
  appliedFilters: Filters[];
  kpi: string;
  segment: string;
  dataType: string;
  isSummary: boolean;
  pageName?: PageName;
}

export interface PerformanceAnalysisboardParam {
  clientId: number;
  productType: ProductType;
  countryIds: string[];
  productGroup: Option[] | undefined;
  period: string;
  comparisonPeriod: RelativePeriod | BaseTimePeriod;
  periodType: Periodicity;
  shareType: ShareType;
  sortOption: SortingOptionsType;
  growthType: GrowthTypes;
  appliedFilters: Filters[];
  segment: string;
  dataType: string;
}
